import React, { createContext, useContext, useState } from "react";
import './layout.scss';
import SideBar from "./sideBar/sideBar";
import Header from "./header/header";

const HeaderTitleContext = createContext();

    export function useHeaderTitle() {
        return useContext(HeaderTitleContext);
    }
export default function Layout({ children ,hideFilters = false}) {
    const [headerTitle, setHeaderTitle] = useState('Job List');
    const [isMenuActive, setIsMenuActive] = useState(false);
    
    // Toggle the active state on button click.
    const tggleMenu = () => {
         console.log("Loading departments, accounts, and countries in layout..."+hideFilters);
        setIsMenuActive(prevState => !prevState);
    };
    return (
        <HeaderTitleContext.Provider value={{ headerTitle, setHeaderTitle }}>
        <section className={`outer-wrapper ${isMenuActive ? 'menu-closed' : 'menu-open'}`}>
            <section className={`design-wrapper ${isMenuActive ? 'filter-closed' : 'filter-open'}`}>
                <Header hideFilters={hideFilters}/>
                <SideBar handleToggle={tggleMenu}/>

                <section className='content-wrapper'>
                    <section className='content-holder'>

                        {children}

                    </section>
                </section>
            </section>
        </section>
 </HeaderTitleContext.Provider>

    )
}